export const heizungswegweiser = [
    {
      "id": 200,
      "type": "radio-step",
      "description":"type of real estate",
      "title": "Es handelt sich um…",
      "options": [
        {  id:"1", value:"... einen Neubau (noch keinen Bauantrag gestellt) in einem Neubaugebiet.", "next" : 201, "prev" : -1, "options": {"icon":"/libs/wizard/check/svg/one_family_house.svg", "text":"... einen Neubau (noch keinen Bauantrag gestellt) in einem Neubaugebiet.", "size":"m"}},
        {  id:"2", value:"... einen Neubau (noch kein Bauantrag gestellt) außerhalb eines Neubaugebiets (Lückenschluss).", "next" : 203, "prev" : -1, "options": {"icon":"/libs/wizard/check/svg/multifamily_house.svg", "text":"... einen Neubau (noch kein Bauantrag gestellt) außerhalb eines Neubaugebiets (Lückenschluss).", "size":"s"}},
        {  id:"2", value:"... eine Bestandsimmobilie.", "next" : 206, "prev" : -1, "options": {"icon":"/libs/wizard/check/svg/multifamily_house.svg", "text":"... eine Bestandsimmobilie.", "size":"s"}},
      ]
    },
  
    {
      "id": 201,
      "type": "info-step",
      "description":"type of real estate",
      "title": "Seit Januar 2024",
      "options": [
        {  id:"2", value:"", "next" : 998, "prev" : -1, "options": {"icon":"/libs/wizard/check/svg/euro_wenig.svg", "text":`
          <p>
				    ... müssen Sie grundsätzlich eine Heizung mit 65 Prozent Erneuerbaren Energien einbauen und betreiben. Es gibt aber auch Übergangsfristen, bspw. zum Anschluss an ein zukünftiges Wärmenetz.<br>
          <br>
        <strong>Wichtig:</strong> Die Pflicht gilt für alle Neubauten, für die ab Januar 2024 der Bauantrag gestellt wird.    
		    </p>
          `, "size":"m"}}, 
      ]
    },
    {
      "id": 203,
      "type": "cards-step",
      "description":"type of real estate",
      "title": "Wie hoch ist die Einwohnerzahl der Stadt oder Gemeinde, in der Ihr Neubau entsteht?",
      "options": [
        {  id:"2", value:`100.000 oder weniger Einwohner`, "next" : 204, "prev" : -1, "options": {"icon":"", "text":"Gering", "size":"m"}},
        {  id:"1", value:`mehr als 100.000 Einwohner`, "next" : 205, "prev" : -1, "options": {"icon":"", "text":"Mittel", "size":"m"}},
        
      ]
    },
    {
      "id": 204,
      "type": "info-step",
      "description":"type of real estate",
      "title": "Seit Januar 2024",
      "options": [
        {  id:"2", value:"", "next" : 998, "prev" : -1, "options": {"icon":"", "text":`
         <div>
  <h2>Nachhaltig Heizen: Ihre Optionen</h2>
  <p><strong>Heizen mit Erneuerbaren Energien</strong> ist klimafreundlich und dank der BEG-Förderung wirtschaftlich attraktiv.</p>
  <ul>
    <li><strong>Bauantrag bis 30.06.2028:</strong> Fossile Heizungen (Öl/Gas) erlaubt, aber mit <strong>Informationspflicht</strong>. Ab 2029: Nutzung von Biomethan oder grünem/blauem Wasserstoff erforderlich.</li>
    <li><strong>Gebiet mit Wärmeplan:</strong> Heizungen müssen <strong>65 % Erneuerbare Energie</strong> nutzen.</li>
    <li><strong>Hinweis:</strong> Steigende CO₂-Preise einkalkulieren.</li>
  </ul>
</div>
          `, "size":"m"}}, 
      ]
    },
    {
      "id": 205,
      "type": "info-step",
      "description":"type of real estate",
      "title": "Seit Januar 2024",
      "options": [
        {  id:"2", value:"", "next" : 998, "prev" : -1, "options": {"icon":"", "text":`
         <div>
          <h2>Heizen mit Erneuerbaren Energien</h2>
          <ul>
            <li><strong>Bis 30.06.2026:</strong> Fossile Heizungen erlaubt, mit <strong>Informationspflicht</strong>.</li>
            <li><strong>Mit Wärmeplan:</strong> Mindestens 65 % Erneuerbare Energie nötig.</li>
            <li><strong>Nach 30.06.2026:</strong> 65 % Erneuerbare Energie verpflichtend.</li>
          </ul>
        </div>
          `, "size":"m"}}, 
      ]
    },
      {
        "id": 206,
        "type": "cards-step",
        "description":"type of real estate",
        "title": "Wie hoch ist die Einwohnerzahl der Stadt oder Gemeinde, in der Ihr Neubau entsteht?",
        "options": [
          {  id:"2", value:`Meine Heizung ist älter als 30 Jahre.`, "next" : 207, "prev" : -1, "options": {"icon":"", "text":"Gering", "size":"m"}},
          {  id:"1", value:`Meine Heizung ist jünger als 30 Jahre.`, "next" : 208, "prev" : -1, "options": {"icon":"", "text":"Mittel", "size":"m"}},
          
        ]
      },
    {
      "id": 207,
      "type": "info-step",
      "description":"type of real estate",
      "title": "Seit Januar 2024",
      "options": [
        {  id:"2", value:"", "next" : 998, "prev" : -1, "options": {"icon":"", "text":`
           <div>
              <h2>Heizkesseltausch & Erneuerbare Energien</h2>
              <ul>
                <li><strong>Heizkesseltausch:</strong> Nach 30 Jahren verpflichtend (z.B. mit Wärmepumpe), mit Ausnahmen.</li>
                <li><strong>Bis 30.06.2028:</strong> Fossile Heizungen erlaubt, ab 2029 Nutzung von Biomethan/Wasserstoff nötig.</li>
                <li><strong>Mit Wärmeplan:</strong> Mindestens 65 % Erneuerbare Energie verpflichtend.</li>
              </ul>
            </div>
          `, "size":"m"}}, 
      ]
    },
    {
      "id": 208,
      "type": "info-step",
      "description":"type of real estate",
      "title": "Seit Januar 2024",
      "options": [
        {  id:"2", value:"", "next" : 998, "prev" : -1, "options": {"icon":"", "text":`
        <div>
  <h2>Heizkesseltausch & Erneuerbare Energien</h2>
  <ul>
    <li><strong>Heizkesseltausch:</strong> Nach 30 Jahren verpflichtend (z.B. mit Wärmepumpe), mit Ausnahmen.</li>
    <li><strong>Bis 30.06.2028:</strong> Fossile Heizungen erlaubt, ab 2029 Nutzung von Biomethan/Wasserstoff nötig.</li>
    <li><strong>Mit Wärmeplan:</strong> Mindestens 65 % Erneuerbare Energie verpflichtend.</li>
  </ul>
</div>
          `, "size":"m"}}, 
      ]
    },
  ]